import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { TextInput } from '../../../../ui/input/text_input/text_input';
import type { IAdministratorSectionProps } from '../interfaces';

export const AdministratorSection: React.FC<IAdministratorSectionProps> = ({
  firstName,
  lastName,
  email,
  onFirstNameChange,
  onLastNameChange,
  onEmailChange,
}) => (
  <Box>
    <Typography
      variant="caption"
      sx={{
        fontWeight: 800,
        color: 'text.secondary',
        textTransform: 'uppercase',
        letterSpacing: '0.15em',
        display: 'block',
        mb: 3,
      }}
    >
      Primary Administrator
    </Typography>
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
        gap: 3,
      }}
    >
      <TextInput
        label="First Name"
        name="firstName"
        value={firstName}
        type="text"
        placeholder="John"
        onChange={(e) => onFirstNameChange(e.target.value)}
      />
      <TextInput
        label="Last Name"
        name="lastName"
        value={lastName}
        type="text"
        placeholder="Doe"
        onChange={(e) => onLastNameChange(e.target.value)}
      />
      <TextInput
        label="Administrator Email"
        name="email"
        value={email}
        type="email"
        placeholder="john.doe@acme.com"
        onChange={(e) => onEmailChange(e.target.value)}
      />
    </Box>
  </Box>
);
